var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useState, } from 'react';
import { chainHandlers } from '../../../../utils/chain-handlers';
import { filteredStringList } from '../../../../utils/filtered-string-list';
import { FieldTextArea } from '../../Elements/FieldTextArea';
import { FieldLabel } from '../../Elements/FieldLabel';
import { FieldSubText } from '../../Elements/FieldSubText';
import styles from '../TextField/TextField.module.scss';
/**
 * @tdr
 * @tdr-candidates: textarea
 */
export var TextArea = forwardRef(function (_a, ref) {
    var advisoryText = _a.advisoryText, ariaDescribedBy = _a.ariaDescribedBy, className = _a.className, defaultValue = _a.defaultValue, disabled = _a.disabled, displayMaxLength = _a.displayMaxLength, errorText = _a.errorText, helpText = _a.helpText, helpTextIconHidden = _a.helpTextIconHidden, id = _a.id, indicateOptional = _a.indicateOptional, indicateRequired = _a.indicateRequired, label = _a.label, labelHidden = _a.labelHidden, maxLength = _a.maxLength, onChange = _a.onChange, required = _a.required, rows = _a.rows, value = _a.value, props = __rest(_a, ["advisoryText", "ariaDescribedBy", "className", "defaultValue", "disabled", "displayMaxLength", "errorText", "helpText", "helpTextIconHidden", "id", "indicateOptional", "indicateRequired", "label", "labelHidden", "maxLength", "onChange", "required", "rows", "value"]);
    var _b = useState(value || ''), inputValue = _b[0], setInputValue = _b[1];
    var hasError = !!errorText;
    var displayCharacterCount = displayMaxLength && maxLength;
    var labelId = "".concat(id, "-label");
    var advisoryTextId = "".concat(id, "-advisoryText");
    var errorTextId = "".concat(id, "-errorText");
    var helpTextId = "".concat(id, "-helpText");
    var describedBy = filteredStringList([
        !!advisoryText && advisoryTextId,
        hasError && errorTextId,
        !!helpText && helpTextId,
        ariaDescribedBy,
    ]);
    return (React.createElement("div", { className: styles.container },
        React.createElement(FieldLabel, __assign({}, {
            id: labelId,
            indicateOptional: indicateOptional,
            indicateRequired: indicateRequired,
            label: label,
            labelForId: id,
            labelHidden: labelHidden,
        })),
        React.createElement(FieldSubText, { hideIcon: helpTextIconHidden, id: helpTextId, text: helpText, type: "help" }),
        React.createElement(FieldTextArea, __assign({}, __assign(__assign({}, props), { 'aria-describedby': describedBy, 'aria-invalid': hasError, 'aria-labelledby': labelId, 'aria-required': required, className: className, defaultValue: defaultValue, disabled: disabled, hasError: hasError, id: id, maxLength: maxLength, onChange: chainHandlers(function (e) { return setInputValue(e.target.value); }, onChange), ref: ref, required: required, rows: rows, value: value }))),
        React.createElement(FieldSubText, { id: errorTextId, text: errorText, type: "error" }),
        (advisoryText || displayCharacterCount) && (React.createElement("div", { className: styles.advisoryText },
            React.createElement(FieldSubText, { id: advisoryTextId, text: advisoryText, type: "advisory" }),
            displayCharacterCount && (React.createElement(FieldSubText, { className: styles.characterCount, text: "".concat(maxLength - inputValue.length, "/").concat(maxLength, " characters left"), type: "advisory" }))))));
});
//# sourceMappingURL=TextArea.js.map